<template>
    <svg :width="width" :height="height" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 682.76 803.65"
        style="enable-background:new 0 0 682.76 803.65;" xml:space="preserve">
        <g>
            <g>
                <circle :style="theme == 'light' ? 'fill: #74bd81;' : 'fill: #FFFFFF;'" cx="339.88" cy="236.11" r="53.89" />
                <g>
                    <defs>
                        <path id="SVGID_1_" d="M503.28,490.91v114.88c0,85.79-66.25,156.1-150.39,162.56c-4.18,0.33-8.41,0.49-12.67,0.49H176.48
					c0-21,8.52-40.01,22.27-53.77c13.76-13.75,32.77-22.27,53.77-22.27h87.72c47.98,0,87.01-39.03,87.01-87.02V490.91
					c0-47.98-39.03-87.01-87.01-87.01v-76.04C430.14,327.86,503.28,401.01,503.28,490.91z" />
                    </defs>
                    <use xlink:href="#SVGID_1_" style="overflow:visible;" />
                    <clipPath id="SVGID_00000034078074251272982010000017326085536055188875_">
                        <use xlink:href="#SVGID_1_" style="overflow:visible;" />
                    </clipPath>
                </g>
                <path :style="theme == 'light' ? 'fill: #74bd81;' : 'fill: #FFFFFF;'" d="M564.84,110.86c-60.09-60.08-139.98-93.19-224.96-93.19c-84.99,0-164.87,33.11-224.97,93.19
			c-60.08,60.09-93.18,139.98-93.18,224.96v27.57l38.02-13.78l38.02,13.78v-27.57c0-133.49,108.61-242.11,242.11-242.11
			c133.49,0,242.11,108.62,242.11,242.11c0,70.57-30.37,134.2-78.71,178.49v-23.4c0-89.9-73.14-163.05-163.05-163.05h-0.35
			c-89.92,0-163.05,73.15-163.05,163.05c0,89.91,73.13,163.05,163.05,163.05c26.78,0,53.06-3.29,78.37-9.67
			c-14.23,28.73-43.86,48.52-78.02,48.52h-87.72c-21,0-40.01,8.51-53.77,22.26c-13.75,13.76-22.26,32.77-22.26,53.77h163.74
			c4.26,0,8.49-0.16,12.67-0.49c83.09-6.39,148.75-75.04,150.36-159.4c22.17-13.3,42.84-29.43,61.59-48.17
			c60.08-60.09,93.18-139.98,93.18-224.96S624.92,170.95,564.84,110.86z M339.88,577.93c-47.98,0-87.01-39.05-87.01-87.02
			c0-47.98,39.03-87.01,87.01-87.01h0.35c47.98,0,87.01,39.03,87.01,87.01v70.71c-0.12,0.05-0.23,0.09-0.35,0.14
			C399.87,572.2,370.53,577.93,339.88,577.93z" />
            </g>
        </g>
    </svg>


</template>

<script>
export default {
    props: {
        width: {
            default: '72px',
            type: String,
        },
        height: {
            default: '72px',
            type: String,
        },
        theme: {
            default: 'light',
            type: String,
        },
    }
}
</script>

<style scoped>
.st0 {
    fill: url(#SVGID_1_);
}

.st1 {
    fill: url(#SVGID_00000117668273515759360250000001361243944117809026_);
}

.st2 {
    fill: url(#SVGID_00000074430426714454412750000010012407725498833319_);
}
</style>